const CRC32C_TABLE = new Int32Array(256);
const POLY = 0x82F63B78; // Reversed Castagnoli polynomial 0x1EDC6F41

for (let i = 0; i < 256; i++) {
  let crc = i;
  for (let j = 0; j < 8; j++) {
    crc = (crc & 1) ? (POLY ^ (crc >>> 1)) : (crc >>> 1);
  }
  CRC32C_TABLE[i] = crc;
}

export function calculateChecksum(data: Uint8Array): number {
  let crc = 0xFFFFFFFF;
  for (let i = 0; i < data.length; i++) {
    crc = CRC32C_TABLE[(crc ^ data[i]) & 0xFF] ^ (crc >>> 8);
  }
  return (crc ^ 0xFFFFFFFF) >>> 0;
}

export function verifyChecksum(data: Uint8Array, expected: number): boolean {
  return calculateChecksum(data) === expected;
}
